<style scoped>
.popup-global-position.k-simple-modal {
  max-height: calc(100vh - 60px);
  width: 90vw;
  top: 30px !important;
  transform: translate(-50%, 0%);
  max-height: calc(100vh - 60px) !important;
  overflow: auto;
  position: fixed;
}

#simple-modal.card-img-overlay {
  position: fixed !important;
}

.close {
  text-align: right;
  margin-bottom: 20px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
}

.card-body {
  position: relative;
}

pre{
  white-space: break-spaces;
}

.p-tab {
  border-radius: 0 !important;
}
</style>

<template>
  <div v-if="show" id="simple-modal-overlay" class="k-overlay" @click="annulla"></div>
  <div v-if="show" id="simple-modal" class="card-img-overlay popup-global-position k-simple-modal">

    <div class="card mb-4">

      <div class="card-body p-5">
        <div class="close" @click="annulla()">
          <i class="pi pi-times" style="font-size: 20px"></i>
        </div>

        <Tabs value="0">
          <TabList>
            <Tab v-if="selectedTask.messaggio" :value="selectedTask.messaggio?'0':'4'" >Messaggio</Tab>
            <Tab :value="selectedTask.messaggio?'1':'0'" >Task Sprint</Tab>
            <Tab :value="selectedTask.messaggio?'2':'1'"  v-if="isPM" @click="loadTicket" >Ticket</Tab>
            <Tab  :value="selectedTask.messaggio?'3':'2'" v-if="titoloLavoro && isPM" @click="loadLavoro">Lavoro</Tab>
            <Tab  :value="selectedTask.messaggio?'4':'3'" v-if="isPM" @click="loadTimbrature">Timbrature</Tab>
            <Tab  :value="selectedTask.messaggio?'5':'4'" v-if="isPM" @click="loadStoria">Storia</Tab>
          </TabList>
          <TabPanels>
            <TabPanel :value="selectedTask.messaggio?'0':'4'" v-if="selectedTask.messaggio">
              <h4 class="">Messaggio</h4>
              <pre v-html="selectedTask.messaggio"></pre>
            </TabPanel>
            <TabPanel :value="selectedTask.messaggio?'1':'0'">
              <h4>DOD - Ticket {{idTicket}}</h4>
              <p style="margin-bottom: 0"><b>Esecutore: </b>{{getEsecutore(selectedTask.idOwner)}}</p>
              <p style="margin-bottom: 0"><b>PM responsabile: </b>{{selectedTask.forcePM?getEsecutore(selectedTask.idPmForzato):selectedTask.nomePM}}</p>
              <p style="margin-bottom: 40px"><b>Effort stimato: </b>{{selectedTask.orePreviste}}h</p>
              <pre>{{ selectedTask.actualDod }}</pre>
            </TabPanel>
            <TabPanel :value="selectedTask.messaggio?'2':'1'" v-if="isPM">
              <h4 class="" v-html="titoloTicket"></h4>
              <pre v-show="ticketLoaded" v-html="descrizioneTicket"></pre>
            </TabPanel>
            <TabPanel :value="selectedTask.messaggio?'3':'2'" v-if="isPM">
              <h4 class="" v-html="titoloLavoro"></h4>
              <pre v-show="lavoroLoaded" v-html="descrizioneLavoro"></pre>
            </TabPanel>
            <TabPanel :value="selectedTask.messaggio?'4':'3'" v-if="isPM">
              <h4 class="">Timbrature</h4>
              <DataTable v-show="timbratureLoaded&& timbrature.length>0" :value="timbrature" tableStyle="min-width: 50rem">
                <Column  header="Data" sortable  style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{ parseData(slotProps?.data?.data) }}
                    </p>
                  </template>
                </Column>
                <Column header="Timbratore" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{ getEsecutore(slotProps?.data?.id_account) }}
                    </p>
                  </template>
                </Column>
                <Column header="Ore timbrate" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{parseMinuti(slotProps?.data?.minuti)}}
                    </p>
                  </template>
                </Column>
                <Column header="Nota" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{slotProps?.data?.nota}}
                    </p>
                  </template>
                </Column>
                <Column header="Nota" style="width:150px">
                  <template #body="slotProps">
                    <CustomButton class="dettaglio" @click="dettaglioNota(slotProps.data)" icon="pi pi-eye" rounded raised />
                  </template>
                </Column>
              </DataTable>
              <p v-show="timbratureLoaded&& timbrature.length<=0">Nessuna timbratura per il ticket {{idTicket}}</p>
            </TabPanel>
            <TabPanel :value="selectedTask.messaggio?'5':'4'" v-if="isPM">
              <DataTable :value="storia" tableStyle="min-width: 50rem">
                <Column field="lastUpdate" header="Data" sortable  style="width:150px">
                </Column>
                <Column header="Utente" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{ getEsecutore(slotProps?.data?.idUtenteModifica) }}
                    </p>
                  </template>
                </Column>
                <Column header="PM Responsabile" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{ getPM(selectedTask) }}
                    </p>
                  </template>
                </Column>
                <Column header="Messaggio" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{ slotProps.data.messaggio }}
                    </p>
                  </template>
                </Column>
                <Column header="Esecutore" v-if="visulizzaOwner">
                  <template #body="slotProps">
                    <p class="m0">
                      {{ getEsecutore(slotProps?.data?.idOwner) }}
                    </p>
                  </template>
                </Column>
                <Column header="Stato" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{ slotProps.data.status }}
                    </p>
                  </template>
                </Column>
                <Column header="" style="width: 80px; max-width: 80px">
                  <template #body="slotProps">
                    <div class="bottoni-storia">
                      <CustomButton class="dettaglio" @click="visualizzaMessaggio(slotProps?.data)" icon="pi pi-eye" rounded raised />
                    </div>
                  </template>
                </Column>
              </DataTable>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </div>
  </div>

  <CustomDialog v-model:visible="showNotaTimbratura" modal :header="titoloModal" :style="{ width: '700px' }">
    <div class="row" style="margin-top: 20px">
      <div class="col-12">
        <div class="flex flex-col gap-1">
          <pre>{{notaTimbratura}}</pre>
        </div>
      </div>
    </div>
  </CustomDialog>

</template>

<script>
import * as $ from 'jquery';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import CustomButton from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import moment from "moment/moment";
import CustomTextArea from "primevue/textarea";
import CustomDialog from "primevue/dialog";

export default {
  name: "KModalDettaglioTicket",
  components: {CustomDialog, Tabs, TabList, Tab, TabPanels, TabPanel, DataTable,Column,CustomButton },

  data() {
    return {
      titoloTicket: '',
      descrizioneTicket: '',
      titoloLavoro: '',
      descrizioneLavoro: '',
      show: false,
      isPM: false,
      selectedTask: {},
      idTicket:'',
      timbrature:[],
      timbratureLoaded:false,
      ticketLoaded:false,
      lavoroLoaded:false,
      showNotaTimbratura:false,
      nomeTimbratore:'',
      dataTimbratura:'',
      notaTimbratura:'',
      storia:[],
      storiaLoaded:false,
      titoloModal:''
    }
  },
  created() {
    $(document).keyup(function (e) {
      if (e.key === "Escape" && this.show) {
        this.annulla()
      }
    }.bind(this));
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'showDettaglioTicket') {
        $('html').css('overflow', 'hidden')
        console.log(mutation.payload);
        this.show = true;
        this.timbrature=[];
        this.timbratureLoaded=false;
        this.storia=[];
        this.storiaLoaded=false;
        this.isPM = mutation.payload.isPM;
        this.selectedTask = mutation.payload.task;
        this.selectedTask.actualDod = this.selectedTask.descrizione;
        this.titoloTicket = mutation.payload.titoloTicket +" - "+mutation.payload.task.idTicket;
        this.idTicket=mutation.payload.task.idTicket;
        this.idTicketLavoro=mutation.payload.idTicketLavoro;
        this.descrizioneTicket = mutation.payload.descrizioneTicket;
        this.titoloLavoro = mutation.payload.titoloLavoro;
        this.descrizioneLavoro = mutation.payload.descrizioneLavoro;
        this.altriDettagli = mutation.payload.altriDettagli;
        // if(this.isPM){
        //   this.$store.dispatch('getTimbratureTicket', { idTicket: this.idTicket });
        // }
      }
      if(mutation.type==='ticketCaricato'){
        this.ticketLoaded=true;
        console.log("ticket caricato:",mutation.payload);
        this.descrizioneTicket = mutation.payload.description;
      }
      if(mutation.type==='lavoroCaricato'){
        this.lavoroLoaded=true;
        console.log("lavoro caricto:",mutation.payload);
        this.descrizioneLavoro = mutation.payload.description;
      }
      if(mutation.type==='timbratureCaricate'){
        this.timbratureLoaded=true;
        this.timbrature=[...mutation.payload];
      }
      if(mutation.type==='visualizzaStoriaTSFromDettaglio'){
        this.storiaLoaded=true;
        this.storia=[...mutation.payload.storico];
      }
    });
  },
  methods: {
    annulla() {
      this.show = false;
      this.titoloTicket = '';
      this.descrizioneTicket = '';
      this.titoloLavoro = '';
      this.descrizioneLavoro = '';
      this.altriDettagli = ''
      $('html').css('overflow', 'auto')
    },


    parseData(data){
     return  moment(data).format('DD/MM/YYYY')
    },

    parseMinuti(minuti){
      let hours = Math.floor(minuti / 60);
      let minutes = minuti % 60;
      let formattedHours = hours < 10 ? '0' + hours : hours;
      let formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

      let timeString = formattedHours + ':' + formattedMinutes;
      return timeString;
    },

    dettaglioNota(timbratura){
      this.showNotaTimbratura=true;
      this.notaTimbratura=timbratura.nota
      this.titoloModal='Nota della timbratura effettuata da '+this.getEsecutore(timbratura.id_account)+' il '+this.parseData(timbratura.data);
    },
    visualizzaMessaggio(storiaTask){
      this.showNotaTimbratura=true;
      let es=this.getEsecutore(storiaTask?.idUtenteModifica);
      this.titoloModal='Messaggio di '+ es+ ' creato il '+storiaTask.lastUpdate
      this.notaTimbratura=storiaTask.messaggio;
    },

    loadTimbrature(){
      if(this.isPM){
        if(!this.timbratureLoaded)
          this.$store.dispatch('getTimbratureTicket', { idTicket: this.idTicket });
        else
          this.timbratureLoaded=true;
      }
    },
    loadLavoro(){
      console.log("idTicketLavoro=",this.idTicketLavoro);
      this.lavoroLoaded=false;
      this.$store.dispatch('loadTicket', { idTicket: this.idTicketLavoro,isLavoro:true });
    },
    loadTicket(){
      this.ticketLoaded=false;
      this.$store.dispatch('loadTicket', { idTicket: this.idTicket });
    },

    loadStoria(){
      if(this.isPM){
        if(!this.storiaLoaded)
          this.$store.dispatch('loadStoriaTaskFromDettaglio', { idTaskSprint: this.selectedTask.id });
        else
          this.storiaLoaded=true;
      }
    },


    getEsecutore(idEsecutore){
      if(!idEsecutore){
        return ''
      }
      if(idEsecutore==-1){
        return 'SYS'
      }
      let esecutore=this.$store.getters.getEsecutoriFilter(""+idEsecutore);
      if(!esecutore || esecutore.length <= 0){
        return ''
      }else{
        return esecutore[0].descrizione;
      }
    },
    getPM(task){
      let ts=this.$store.getters.getTaskById(task.id);
      if(ts){
        if(ts[0].forcePM){
          return this.getEsecutore(ts[0].idPmForzato)
        }else{
          return this.getEsecutore(ts[0].idPM)
        }
      }
    }
  }
}
</script>